const initialState = {
    categories: [],
    auth: {}
}

export default initialState